import React, { useEffect } from 'react';
import FlipCardSlider from '../../components/Slider/FlipCardSlider';
import ArticleContainer from '../../components/Article/ArticleContainer';
import ArticleHero from '../../components/Hero/ArticleHero';
const relatedBlogs = [
    {
      contentType: "BLOG",
      title: "Complimenting Fleet Modernization with Road Safety",
      description: "Shoora is leading the charge in transforming fleet operations by enhancing safety and operational efficiency through the Voluntary Vehicle-Fleet Modernization Programme (VVMP).",
      link: "/insights/blog/complimenting-fleet-modernization-with-road-safety",
      linkText: "Read article",
      thumbnail:
        "https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    readTime: 10,
      },
    {
      contentType: "BLOG",
      title: "Envisioning the Future of Mobility with Shoora",
      description:
        "Shoora offers comprehensive fleet management solutions that track vehicle locations, monitor driver performance, optimise routes, and reduce fuel consumption.",
      thumbnail:
        "/images/thumbnails/14.jpeg",
      link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
    readTime: 10,
    },
    {
      contentType: "BLOG",
      title: "Leverage AIS-140’s Mandate for Telematics Devices",
      description:
        "Shoora, a leader in advanced video telematics solutions , is committed to harnessing the potential of this mandate to create safer roads and smarter transportation systems.",
      thumbnail: "https://www.easyembedded.net/images/ais2.jpg",
      link: "/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles",
    readTime: 10,
    },
    {
      contentType: "BLOG",
      title: "Tackling Distracted Driving: Transforming Fleet Safety",
      description:
        "By adopting the Three Ts—Talk, Train, and Track, Shoora addresses distracted driving head-on, protecting lives and optimising operations.",
      thumbnail: "/images/thumbnails/3.jpeg",
      link: "/insights/blog/tackling-distracted-driving-transforming-fleet-safety",
    readTime: 10,
    },
    {
      contentType: "BLOG",
      title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
      description:
        "Shoora, through its advanced video telematics solutions, is helping to curb these numbers and protect lives.",
      thumbnail:
        "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600",
      link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
    readTime: 10,
    },
    {
      contentType: "CUSTOMER STORY",
      title: "Shoora Life Savers Helped BLR Logistics Avert Over 7,500 Accidents",
      description:
        "Shoora is not just a service provider for BLR Logistics; they are a trusted safety partner.",
      thumbnail:
        "https://images.jdmagicbox.com/v2/comp/mumbai/26/022p1955726/catalogue/blr-logistics-india-ltd-goregaon-east-mumbai-transporters-for-all-india-3m98o5wutw.jpg",
      link: "/insights/customer-stories/how-shoora-life-savers-helped-blr-logistics-avert-over-7500-accidents",
    readTime: 10,
    },
  

  ];
const data = {
    contentType: 'CUSTOMER STORY',
    title: 'Kapoor Diesels Truck Achieves 1,60,200 Accident-Free Kilometres with Shoora’s Cutting-Edge Video Telematics Solutions',
    description: 'The integrated suite of technologies offered Kapoor Diesel enhanced safety, better fleet management, and measurable cost savings.',
    author: 'Kapoor Diesel',
    createdOn: '26th Oct, 2024',
    imgsrc: '/images/thumbnails/15.jpeg',
    readTime: 10,
    content: `
    <div>
        <h6>Industry:</h6>
        <p>Trucking and Freight Logistics</p>
    </div>
        <br /><br />
    <h2>The Challenge</h2>
    <p>
        Kapoor Diesel, a leading fleet operator, faced a persistent challenge in the highly competitive logistics industry: ensuring driver safety while maintaining operational efficiency. High accident rates, rising costs from damages, and increasing safety concerns over driver distractions required an immediate solution. Kapoor Diesel needed a way to improve driver behaviour, reduce accidents, optimise fleet performance, and safeguard both drivers and cargo.
    </p>
    <br /><br />
    <h2>The Solution</h2>
    <p>
    Shoora’s state-of-the-art video telematics solutions provided the ideal answer. The integrated suite of technologies offered Kapoor Diesel enhanced safety, better fleet management, and measurable cost savings. Key features included:
    </p>
   
    <ol>
    <li>
    <h4>CabinAlerts</h4>
    <p>
    AI-driven, real-time alerts kept drivers on track by notifying them instantly of unsafe behaviours like speeding, distraction, and drowsiness. These alerts, tailored in the local language, ensured rapid driver compliance and behaviour correction.
    </p>
    </li>
    <li>
    <h4>FleetSense™</h4>
    <p>
    Shoora’s GPS-enabled platform provided comprehensive fleet management, offering real-time diagnostics, route optimization, and fuel tracking. It empowered Kapoor Diesel to reduce fuel wastage and boost overall operational efficiency.
    </p>
    </li>
    <li>
    <h4>On-Demand Video Access</h4>
    <p>
    The system’s high-definition dash cams delivered clear, instant video footage of any events or risky behaviour, providing vital evidence for incident resolution and reducing liability.
    </p>
    </li>
    <li>
    <h4>RoadSense™</h4>
    <p>
    Advanced AI-powered collision detection, lane departure warnings, and proactive coaching kept drivers safe by preventing accidents before they could happen.
    </p>
    </li>
    <li>
    <h4>Real-Time Driver Coaching</h4>
    <p>
     Shoora’s 24/7 Control Room monitored the fleet, enabling immediate intervention with drivers to coach them on safer driving, minimising risks on the road.
    </p>
    </li>
    </ol>
    <h2>The Results</h2>
    <p>
    Thanks to Shoora’s telematics technology, Kapoor Diesel’s truck achieved the remarkable feat of travelling <strong>160,200 kilometres without a single accident</strong>. Key benefits included:
    </p>
   
    <ul>
    <li>
    <h4>Unmatched Driver Safety</h4>
    <p>
     Real-time alerts and coaching reduced risky behaviours like distracted driving, fatigue, and speeding, ensuring drivers remained focused and safe on the road.
    </p>
    </li>
    <li>
    <h4>Significant Cost Savings</h4>
    <p>
    Fewer accidents led to lower insurance premiums, fewer repair costs, and reduced legal liabilities. Additionally, optimised fuel management and route planning translated into operational savings.
    </p>
    </li>
    <li>
    <h4>Boosted Fleet Efficiency</h4>
    <p>
    Shoora’s insights allowed Kapoor Diesel to make data-driven decisions, optimising routes, improving driver performance, and reducing downtime. This resulted in heightened productivity across the fleet.
    </p>
    </li>
    <li>
    <h4>Risk Mitigation and Compliance</h4>
    <p>
    Shoora’s instant alerts and event footage gave Kapoor Diesel the tools to remain compliant with regulations, while also offering real-time risk management and accident prevention.
    </p>
    </li>
    
    </ul>

    <blockquote>

                       "Adopting Shoora’s advanced video telematics has transformed our fleet operations. Not only has it enhanced safety, but it has also improved our bottom line. Real-time feedback, coupled with instant video footage, has helped us drive safer behaviours and reduce costs across the board."

                       <h4>&mdash;Rohit Kapoor, Owner, Kapoor Diesel</h4>
                    </blockquote>
<h2>Conclusion</h2>
    <p>
   Kapoor Diesel’s success in operating over <strong>160,200 accident-free kilometres</strong> underscores the power of Shoora’s telematics solutions in reshaping fleet safety and efficiency. By leveraging AI, IoT, and real-time analytics, Kapoor Diesel has set a new benchmark in the trucking industry. Shoora continues to lead the charge in providing innovative solutions that redefine fleet management, drive operational excellence, and enhance safety.
    </p>
   `
}
const KapoorDiesel = () => {
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
    return (
        <>
            <ArticleHero
                contentType={data?.contentType}
                title={data?.title}
                createdOn={data?.createdOn}
                imgsrc="/images/about/bg8.webp"
                customStyle={{
                    title: {
                        fontSize: '45px',
                    }
                }}
            />
            <div className="bg-dark">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="#">Home</a></li>
                            <li class="breadcrumb-item"><a href="#">Insights</a></li>
                            <li class="breadcrumb-item"><a href="#" className='text-capitalize'>{data?.contentType}s</a></li>
                            <li class="breadcrumb-item active" aria-current="page">{data?.title}</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <ArticleContainer data={data} />
            <hr className='border-3' style={{ borderColor: "var(--accent-color)" }} />
            <div
                className="stories-section section my-5"
                style={{ maxWidth: "100%" }}
            >
                <div className="container">
                    
                <FlipCardSlider data={relatedBlogs} title={"You may also like"}/>
                </div>
            </div>
        </>
    )
}

export default KapoorDiesel